import { currentSession } from "../aws/authentication/UserAuth";
import axios from "axios";
// noinspection JSUnusedGlobalSymbols
export const DELETE_ACCOUNT_ACTION = 'user/delete';
// noinspection JSUnusedGlobalSymbols
export const ADMIN_DELETE_ACCOUNT_ACTION = 'admin/delete';
export const UPDATE_ATTRIBUTE_ACTION = 'user/update-attributes';
export const ADMIN_UPDATE_ATTRIBUTE_ACTION = 'admin/update-attributes';
export const ADMIN_REMOVE_REGISTRATION = 'admin/remove-registration';
export const REMOVE_REGISTRATION = 'user/remove-registration';
export const ADMIN_UPDATE_MFA = 'admin/update-mfa';
export const UPDATE_MFA = 'user/update-mfa';

// noinspection JSUnusedGlobalSymbols
export const ADMIN_REGISTER_MACHINE = 'admin/new-registration';
// noinspection JSUnusedGlobalSymbols
export const REGISTER_MACHINE = 'user/new-registration';

// noinspection JSUnusedGlobalSymbols
export const DELETED_ACCOUNT = 'disabled';
// noinspection JSUnusedGlobalSymbols
export const ACTIVE_ACCOUNT = 'enabled';

// noinspection JSUnusedGlobalSymbols
export function fetchLog(cognito_sub, onSuccess, onFailure, offset = 0, limit = 10) {
  currentSession(session => {
    axios.get(process.env.SISER_API_ENDPOINT + 'user/admin/change-log/' + cognito_sub + "?offset=" + offset + '&limit=' + limit, {
      headers: {
        "Authorization": session['idToken']['jwtToken'],
        'X-Siser-Elevated-Roles': '1'
      }
    }).then(response => {
      onSuccess(response.data);
    }).catch(err => {
      onFailure(err);
      console.log(err);
    });
  }, () => {});
}
export function logChange(name, previous_value, new_value, action_key, modifier_sub, modified_sub) {
  if (typeof previous_value === "object" && typeof new_value === "object") {
    let values = findObjectDifference(previous_value, new_value);
    if (!values) return;else {
      previous_value = values.previous_value;
      new_value = values.new_value;
    }
  }
  let metaData = '';
  if (typeof window !== 'undefined') {
    metaData = window.navigator.userAgent;
  }
  currentSession(session => {
    axios.post(process.env.SISER_API_ENDPOINT + 'user/admin/change-log', {
      name: name,
      previous_val: previous_value,
      new_val: new_value,
      action_key: action_key,
      modifier_sub: modifier_sub,
      modified_sub: modified_sub,
      meta_data: metaData
    }, {
      headers: {
        "Authorization": session['idToken']['jwtToken']
      }
    }).then(() => {}).catch(err => {
      console.log(err);
    });
  }, () => {});
}
function findObjectDifference(previous_value, new_value) {
  if (previous_value === new_value) {
    return false;
  }
  let return_val = {
    previous_value: {},
    new_value: {}
  };

  // handle changes from original value
  let changes = Object.keys(previous_value).filter(key => {
    return previous_value[key] !== new_value[key];
  });

  // handle values that have been removed/added
  let removed = [];
  let added = [];
  if (Object.keys(previous_value).length > Object.keys(new_value).length) {
    removed = Object.keys(previous_value).filter(key => {
      return typeof new_value[key] === 'undefined';
    });
  } else if (Object.keys(new_value).length > Object.keys(previous_value).length) {
    added = Object.keys(new_value).filter(key => {
      return typeof previous_value[key] === 'undefined';
    });
  }
  let changed = changes.concat(removed, added);
  let password = changed.indexOf('password');
  if (password !== -1) {
    changed.splice(password, 1);
  }
  changed.forEach(change => {
    return_val.previous_value[change] = previous_value[change];
    return_val.new_value[change] = new_value[change];
  });
  return return_val;
}